module.exports = __webpack_public_path__ + "static/banner-4985d82e5a94ba60fba6cb7ec08db23d.png";